<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      row-id="fabricRequestCode"
      round
      auto-resize
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_choice') || '选择'"
            placement="top"
          >
            <i
              class="el-icon-check tool-btn"
              @click="choose(row.fabricRequestCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      fullScreenLoading: false,
      tableHeight: 400,
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
      },
      tableColumn: [
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 80,
          fixed: 'right',
          slots: { default: 'opt' },
        },
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'fabricRequestNo',
          width: 150,
          title: this.$l('INDEX.label_request_billno') || '开发单号',
        },
        {
          field: 'fabricAgentName',
          width: 120,
          title: this.$l('INDEX.choose_fabric_agent') || '业务员',
        },
        {
          field: 'fabricNo',
          width: 180,
          title: this.$l('INDEX.choose_fabric_fabricNo') || '面料编号',
        },
        {
          field: 'fabricName',
          minWidth: 200,
          title: this.$l('INDEX.choose_fabric_fabricName') || '面料名称',
        },
        {
          field: 'factoryNumber',
          width: 160,
          title:
            this.$l('INDEX.choose_fabric_factoryFabricNumber') ||
            '工厂面料编号',
        },
        {
          field: 'fabricContent',
          minWidth: 200,
          title: this.$l('INDEX.choose_fabric_content') || '面料成分',
        },
        {
          field: 'supName',
          minWidth: 250,
          title: this.$l('INDEX.choose_fabric_supName') || '供应商',
        },
      ],
    }
  },
  methods: {
    // 选择开发单
    choose(fabricRequestCode) {
      let msg = this.$l('INDEX.tips_question_select') || '是否确认选择?'
      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.fullScreenLoading = true
        this.$api
          .fabricStockInRequestSaveApi({ fabricRequestCode: fabricRequestCode })
          .then((res) => {
            this.fullScreenLoading = false
            this.$message.success(this.$l('INDEX.tips_save_ok') || '保存成功!')
            this.$emit('submit', res.body)
          })
          .catch(() => {
            this.fullScreenLoading = false
          })
      })
    },
  },
}
</script>
